<template>
  <div ref="badgeRef" class="wc-payment-badge text-truncate">
    <span>{{ paymentOption.label }}</span>

    <!-- target matches the ref name on the parent div so WCToolTip can anchor itself -->
    <WCToolTip v-if="isTruncated" target="badgeRef">
      {{ paymentOption.label }}
    </WCToolTip>
  </div>
</template>

<script setup lang="ts">
import WCToolTip from '@/components/WCToolTip/WCToolTip.vue';
import { defineProps, ref, onMounted } from 'vue';
import WebPaymentMethod from '@/models/entities/items/web-payment-method';

type DisplayablePaymentOption = WebPaymentMethod & { label: string };

defineProps<{
  paymentOption: DisplayablePaymentOption;
}>();

const isTruncated = ref(false);
const badgeRef = ref<HTMLElement | null>(null);

onMounted(() => {
  // scrollWidth > clientWidth means the text is clipped by CSS text-overflow,
  // so we show a tooltip with the full label.
  if (badgeRef.value) {
    isTruncated.value = badgeRef.value.scrollWidth > badgeRef.value.clientWidth;
  }
});
</script>

<style scoped lang="scss">
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-payment-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.1875rem 0.375rem;
  font-size: 0.625rem;
  font-weight: 500;
  color: $product-card-payment-badge-color;
  background-color: $product-card-payment-badge-background-color;
  border: 0.0625rem solid $product-card-payment-badge-border-color;
  border-radius: 0.625rem;
  white-space: nowrap;
  line-height: 1;
  text-align: center;
}
</style>
